module.exports = __webpack_public_path__ + "img/graffiti_walls_at_animarte_nam_van.baa80061.jpg";